import camelCase from 'lodash/camelCase';
import get from 'lodash/get';
import { createSelector } from 'reselect';

import { LOADER_NAMESPACE } from 'src/components/OligosForm/constants';
import { state as stateConstants } from 'src/constants';
import selectorConstants from './constants';

export const selectStateData = (namespace, identifier = '') => (state) => {
  const storePath = identifier ? [camelCase(namespace), camelCase(identifier)] :
    [camelCase(namespace)];

  return get(state.domain, storePath);
};

export const selectLoaderData = (state) => selectStateData(LOADER_NAMESPACE)(state) || false;

export const selectNotifications = (state) => selectStateData('notifications')(state) ||
  selectorConstants.EMPTY_ARRAY;

// export const selectListData = (Model) => createSelector(
//   [selectStateData(Model.NAME, stateConstants.IDENTIFIER_TYPE_LIST)],
//   (listData) => {
//     if (!listData?.data) {
//       return {
//         list: selectorConstants.EMPTY_ARRAY,
//         totalItems: 0
//       };
//     }

//     return {
//       list: listData.data.map((listItem) => new Model(listItem)),
//       totalItems: listData.totalItems
//     };
//   }
// );

export const selectDetailsData = (
  Model,
  identifier = stateConstants.IDENTIFIER_TYPE_DETAILS
) => createSelector([selectStateData(Model.NAME, identifier)], (detailsData) => {
  if (!detailsData || !detailsData.data) {
    return selectorConstants.EMPTY_OBJECT;
  }

  return new Model(detailsData.data);
});
